import React, { useEffect } from 'react';
import { useFitPriceTextIntoPlanCard } from '../hooks/use-fit-price-text-into-plan-card';

export type HighestDisplayPriceProps = {
  readonly cardWidth: number;
  readonly onFontSizeHandler: (fontSize: string) => void;
};

export const HighestDisplayPriceFontSize = ({
  cardWidth,
  onFontSizeHandler
}: HighestDisplayPriceProps) => {
  const { ref, fontSize, highestDisplayPrice } = useFitPriceTextIntoPlanCard();

  useEffect(() => {
    onFontSizeHandler(fontSize);
  }, [fontSize]);

  return (
    <div style={{ fontSize: '54px' }}>
      <div
        ref={ref}
        style={{
          fontSize,
          height: '60px',
          lineHeight: '54px',
          margin: 0,
          fontFamily: 'Charlie Display',
          fontWeight: 500,
          verticalAlign: 'center',
          textAlign: 'center',
          width: `${cardWidth}px`,
          border: '2px solid red',
          position: 'absolute',
          left: '-9999999px',
          top: '-9999999px'
        }}
      >
        {highestDisplayPrice}
      </div>
    </div>
  );
};
